import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import SidebarNav from "./components/sidebar/SidebarNav";
import { sidebarWidth } from "./components/sidebar/state";

const __default__ = {
  components: { SidebarNav },
  props: {},
  setup() {
    return { sidebarWidth };
  },
};
import { Authenticator } from "@aws-amplify/ui-vue";
import "@aws-amplify/ui-vue/styles.css";

import Amplify from "aws-amplify";
import awsconfig from "./aws-exports";


export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {

Amplify.configure(awsconfig);

return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_unref(Authenticator), null, {
    default: _withCtx(({}) => [
      _createVNode(_unref(SidebarNav)),
      _createElementVNode("div", {
        style: _normalizeStyle({ 'margin-left': _unref(sidebarWidth) })
      }, [
        _createVNode(_component_router_view)
      ], 4)
    ]),
    _: 1
  }))
}
}

})